import { TestId } from '@repo/test-id';

import BlikPhoneDecoration from '@features/reservation/components/payment/BlikPhoneDecoration';

import PageFrame from '@shared/components/page/PageFrame';

interface Props {
  onGoBack: () => void;
}

export default function PaymentBlikWaitContents({ onGoBack }: Props) {
  const testId = TestId.root('reservation.blikWait');

  return (
    <PageFrame fullScreen testId={testId} onGoBack={onGoBack}>
      <div className="flex h-full w-full items-center justify-center p-4 text-center">
        <div className="inline-flex w-80 flex-col items-center justify-start gap-3">
          <BlikPhoneDecoration />
          <div className="text-heading justify-start text-2xl leading-8 font-semibold">Potwierdź płatność</div>
          <div className="text-body justify-start text-base leading-6 font-normal">
            Potwierdź płatność BLIK w aplikacji swojego banku. Czekamy na potwierdzenie…
          </div>
        </div>
      </div>
    </PageFrame>
  );
}
